import { trackErrorBlacklist } from '@shared/api-client/config';
import { ToastType } from '@/component/Toast';
import { add } from '@/component/Toast/toastManager';
import { appInsights } from '@/feature/insights/appInsights';
import { excludeProps } from '@/util/object';

async function trackError(error: any, variables: any) {
  try {
    const { status, response, url, method } = error;
    if (!Number.isFinite(status)) {
      return;
    }
    const isClientError = status >= 400 && status <= 499;
    const isBlacklisted = trackErrorBlacklist.includes(status);
    if (!isClientError || isBlacklisted) {
      return;
    }

    const requestBody = excludeProps(
      variables,
      ['password', 'confirmation'],
      '***'
    );
    let responseBody: null | string | object = null;
    try {
      responseBody = await response.text();
      if (typeof responseBody === 'string') {
        responseBody = JSON.parse(responseBody);
      }
    } catch {
      // Ignore JSON parse errors - response may not be valid JSON
    }

    const exception = new Error(`Http request: Client error (4xx)`);
    exception.cause = error;

    appInsights.trackException({
      exception,
      properties: { apiUrl: url, method, requestBody, responseBody },
    });
  } catch (error) {
    console.log('Failed to track error', error);
  }
}

async function getErrorMessage(
  error: any
): Promise<{ message: string; path: boolean }> {
  if (error.status === 403) {
    return { message: 'common.error.unauthorized', path: true };
  }

  return { message: 'common.error.saveDataError', path: true };
}

export async function defaultMutationErrorHandler(
  error: any,
  variables: any,
  _context: any
) {
  const { message, path } = await getErrorMessage(error);

  add({
    message,
    type: ToastType.Error,
    path,
  });

  await trackError(error, variables);
}
